'use client';
import styled from 'styled-components';

export const MarketingHeaderWrapper = styled.div`
  @media ${props => props.theme.laptopL} {
    nav {
      max-width: 1472px;
      margin: auto;
    }
  }
`;
